/** Entspricht Backend AccessRules.AppliesToStudio für Artikel-Verkauf. */
export function articleAppliesToSaleStudio(article: { studioIds?: string[] | null }, saleStudioId: string | null | undefined): boolean {
  const ids = article.studioIds ?? [];
  if (ids.length === 0) return true;
  const sid = (saleStudioId ?? "").trim();
  if (!sid) return false;
  return ids.includes(sid);
}

/** Artikel für Vertragsvorlage: mindestens ein gemeinsames Studio mit Template-Whitelist, oder eine Seite „alle“. */
export function articleCompatibleWithTemplateStudios(
  article: { studioIds?: string[] | null },
  templateAllowedStudioIds: string[] | undefined | null
): boolean {
  const aids = article.studioIds ?? [];
  if (aids.length === 0) return true;
  const tid = (templateAllowedStudioIds ?? []).map(String).filter(Boolean);
  if (tid.length === 0) return true;
  return aids.some((id) => tid.includes(id));
}
